import { ComponentType } from 'react';
import { useAuth } from '@features/auth/context/AuthContext';
import PublicLayout from '@layouts/PublicLayout';
import { Navigate } from 'react-router-dom';

export const ROUTE_TYPES = {
  PRIVATE: 'private',
  PUBLIC: 'public',
} as const;

type RouteType = (typeof ROUTE_TYPES)[keyof typeof ROUTE_TYPES];

export function withAuthProtection(
  Component: ComponentType<any>,
  routeType: RouteType
) {
  function ProtectedRoute(props: any) {
    const { user } = useAuth();

    // Logica para rutas privadas
    if (routeType === ROUTE_TYPES.PRIVATE) {
      if (!user) {
        return <Navigate to="/login" />;
      }
      return <Component {...props} />;
    }

    // Logica para rutas publicas
    if (routeType === ROUTE_TYPES.PUBLIC) {
      if (!user) {
        return (
          <PublicLayout title={props.title}>
            <Component {...props} />
          </PublicLayout>
        );
      }
      return <Navigate to="/" />;
    }

    return <Component {...props} />;
  }

  return ProtectedRoute;
}
